/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import Tooltip from '@mui/material/Tooltip';
import React from 'react';

import styles from './TooltipIcon.module.scss';
import info from './info.svg';
import { RenderedHTML } from './RenderedHtml/RenderedHTML';

type TooltipIconProps = {
  className?: string;
  tooltip?: string;
  tooltipHeader?: string;
  forceShowTooltip?: boolean;
  pageId?: string;
  onTooltipClick?: (element: HTMLElement, message: string, header: string) => void;
};
/* Note that Tooltip sends a forwardRef to its child, and Icon doesn't like that.
   So we need a div for the Tooltip to attach the title to.
 */
export function TooltipIcon({
  className,
  tooltip,
  pageId,
  tooltipHeader,
  onTooltipClick,
  forceShowTooltip,
}: TooltipIconProps) {
  const [tooltipOpen, setTooltipOpen] = React.useState(false);

  if (!tooltip && !forceShowTooltip) {
    return null;
  }

  return tooltip ? (
    <Tooltip
      title={
        <RenderedHTML
          content={tooltip}
          className="darktheme"
          onClick={() => setTooltipOpen(false)}
          onMouseLeave={() => setTooltipOpen(false)}
          pageId={undefined}
          documentVersionId={undefined}
          // pageId={pageId}
          // documentVersionId={documentVersionId}
          // We don't actually want to pass pageId here,
          // Otherwise we'll get the contextualization sidebar
          // flicker into view when we hover over the tooltip
        />
      }
      open={tooltipOpen}
      disableFocusListener
      disableTouchListener
      disableHoverListener
    >
      <div className={className} data-testid="tooltip-icon">
        <div className={styles.tooltipBadge}>
          <img
            src={info}
            width={20}
            height={20}
            alt="More info"
            onMouseEnter={() => setTooltipOpen(true)}
            onMouseLeave={() => setTooltipOpen(false)}
            onBlur={() => setTooltipOpen(false)}
            onClick={(e) => {
              setTooltipOpen(false);
              onTooltipClick?.(e.currentTarget, tooltip || '', tooltipHeader || '');
              e.stopPropagation();
            }}
          />
        </div>
      </div>
    </Tooltip>
  ) : (
    <Tooltip title="Add tooltip" open={tooltipOpen} disableFocusListener disableTouchListener disableHoverListener>
      <div className={className}>
        <div className={`${styles.tooltipBadge} ${styles.greyOut}`}>
          <img
            src={info}
            width={20}
            height={20}
            alt="More info"
            onMouseEnter={() => setTooltipOpen(true)}
            onMouseLeave={() => setTooltipOpen(false)}
            onBlur={() => setTooltipOpen(false)}
            onClick={(e) => {
              setTooltipOpen(false);
              onTooltipClick?.(e.currentTarget, tooltip || '', tooltipHeader || '');
              e.stopPropagation();
            }}
          />
        </div>
      </div>
    </Tooltip>
  );
}
